<template>
  <div class="tooltip">
    <button
      ref="toggle"
      type="button"
      class="tooltip__toggle"
      @click="toggle"
    />
    <div
      v-if="message"
      :style="position"
      class="tooltip__content"
      :class="{
        tooltip__content_visible: isVisible,
        tooltip__content_right: toRight,
        tooltip__content_bottom: toBottom,
      }"
    >
      <div
        ref="message"
        class="tooltip__message"
      >
        <BaseText
          v-bind="message"
        />
        <button
          v-if="hasCloseButton"
          type="button"
          class="tooltip__close"
          @click="hide"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'BaseTooltip',
  components: {
    BaseText,
  },
  props: {
    message: {
      type: Object,
      default: null,
    },
    hasCloseButton: {
      type: Boolean,
      default: true,
    },
    action: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      isVisible: false,
      toRight: false,
      toBottom: false,
      position: null,
    };
  },
  methods: {
    hide() {
      this.isVisible = false;
    },
    toggle() {
      if (typeof this.action === 'function') {
        this.action();
        return;
      }
      this.isVisible = !this.isVisible;
      this.setPosition();
    },
    setPosition() {
      const { toggle, message } = this.$refs;
      const rect = toggle.getBoundingClientRect();

      this.toRight = rect.x > (window.innerWidth / 2);
      this.toBottom = rect.y - message.clientHeight < 0;

      const top = this.toBottom ? rect.top + rect.height : 0;
      const bottom = this.toBottom ? 0 : (window.innerHeight - rect.y);
      const left = this.toRight ? 0 : rect.x;
      const right = this.toRight ? (window.innerWidth - (rect.x + rect.width)) : 0;

      this.position = {
        top: `${top}px`,
        bottom: `${bottom}px`,
        left: `${left}px`,
        right: `${right}px`,
      };
    },
  },
};
</script>

<style lang="stylus">
.tooltip

  &__toggle
    display inline-flex
    align-items center
    justify-content center
    vertical-align top
    width 1.8em
    height @width
    font-family inherit
    font-size 1em
    text-decoration none
    background-color $c_border
    color $c_primary
    border-radius 50%
    padding 0
    margin 0
    border 0
    outline none
    &:before
      content 'i'
      font-size 1.2em
      font-weight 700
      font-family serif
      font-style italic

  &__content
    fix top bottom left right
    display flex
    align-items flex-end
    visibility hidden
    padding 0.5em
    padding-left 0
    pointer-events none
    z-index 30
    &_visible
      visibility visible
    &_right
      justify-content flex-end
      padding-right 0
    &_bottom
      align-items flex-start

  &__message
    position relative
    display block
    width fit-content
    max-width 44em
    padding 1em 3em 1em 1.5em
    background-color $c_tip
    color darken(@background-color, 68%)
    pointer-events auto
    border-radius 0.2em

  &__close
    abs top 50% right
    width 1.8em
    height @width
    background none
    outline none
    margin-top (@height / 2 * -1)
    margin-right 0.3em
    border 0
    z-index 5
    &:after
      content ''
      display block
      width 100%
      height 100%
      background url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Cpath d='M26 26L6 6M26 6L6 26' stroke-linecap='round' stroke='%23856404' stroke-width='3'/%3E%3C/svg%3E") no-repeat center
</style>
